module.exports = (s) => {
  return [
    {
      name: '视频封面图',
      value: 'video_cover_url',
      format: (row) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('material-preview',
              {
                props: {
                  'materialType': 1,
                  'material-list': [
                    {
                      thumb_url: row.video_cover_url,
                      url: row.video_cover_url,
                    },
                  ],
                },
              }, ''),
          ]);
        return ele;
      },
    },
    {
      name: '视频标题',
      value: 'video_title',
    },
    {
      name: '抖音昵称',
      value: 'aweme_name',
    },
    {
      name: '素材标签',
      value: 'material_properties',
      format: (row) => {
        const h = s.$createElement;
        const createLink = (text, type = 'default') => {
          const theme_color = {
            default: '#606266',
            danger: '#F56C6C',
          };
          return h('span', {
            style: {
              color: theme_color[type],
            },
          }, text);
        };

        const material_properties_elements = [];
        const material_properties = row.material_properties || {};

        // 定义素材标签配置
        const material_tags = [
          { condition: material_properties.is_first_publish_material, link: createLink('首发素材') },
          { condition: material_properties.is_high_quality_material, link: createLink('优质素材') },
          { condition: material_properties.is_inefficient_material, link: createLink('低效素材', 'danger') },
        ];

        // 根据条件添加素材标签
        material_tags.forEach(({ condition, link }, index) => {
          if (condition) {
            if (index > 0 && material_properties_elements.length > 0) {
              material_properties_elements.push(h('span', null, '、'));
            }
            material_properties_elements.push(link);
          }
        });

        return h('div', null, material_properties_elements.length > 0 ? material_properties_elements : '-');
      },
    },
    {
      name: '视频发布时间',
      value: 'star_video_publish_time',
      width: 150,
    },
    {
      name: '视频预览',
      value: 'video_play_link',
      format: (row) => {
        const h = s.$createElement;
        const link_ele = h('a',
          {
            class: 'block w-full truncate',
            attrs: {
              target: '_blank',
              href: row.video_play_link,
            },
            style: {
              color: '#409eff',
              textDecoration: 'underline',
            },
            on: {
              click: (e) => {
                e.stopPropagation();
              },
            },
          },
          row.video_play_link,
        );
        return h('div', null, [link_ele]);
      },
    },
  ];
};
